

































































import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { Format } from "../core/helpers/formatHelper";
import { DateHelper } from "../core/helpers/dateHelper";
import store from "../core/store";
import CancelReturnsInfo from "../components/cancelReturnsInfoCz/cancelReturnsInfoCz.vue";
import CzPage from "../components/cz/CzPage.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzChip from "../components/cz/CzChip.vue";
import CzTitle from "../components/cz/CzTitle.vue";
import CzButton from "../components/cz/CzButton.vue";
import CzLink from "../components/cz/CzLink.vue";
import CzNotice from "../components/cz/CzNotice.vue";

@Component({
  components: {
    CancelReturnsInfo,
    CzPage, CzCard, CzChip, CzTitle, CzButton, CzLink, CzNotice,
  },
})
export default class MyBookingsPage extends Vue {
  data: any = null;
  videoCalls: { [id: number]: { url: string; from: Date; to: Date } } = {};
  errorMsg: string = "";
  infoReturns: any = null;
  reload: number = 1;
  showAllPast: boolean = false;

  get next() {
    return this.data && this.data.next ? this.data.next : [];
  }

  get past() {
    return this.data && this.data.past ? this.data.past : [];
  }

  get visiblePast() {
    return this.showAllPast ? this.past : this.past.slice(0, 3);
  }

  get hiddenPastCount() {
    return this.showAllPast ? 0 : Math.max(this.past.length - 3, 0);
  }

  get culture() {
    const c = store.state.settings ? store.state.settings.Culture : "";
    return c ? c : "en-US";
  }

  get todayLabel() {
    return new Intl.DateTimeFormat(this.culture, {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(new Date());
  }

  formatStart(dt: string) {
    const d = new Date(dt);
    const date = new Intl.DateTimeFormat(this.culture, {
      weekday: "short",
      day: "numeric",
      month: "short",
    }).format(d);
    const time = new Intl.DateTimeFormat(this.culture, {
      hour: "2-digit",
      minute: "2-digit",
    }).format(d);
    return `${date} · ${time}`;
  }

  formatPast(dt: string) {
    const d = new Date(dt);
    const date = new Intl.DateTimeFormat(this.culture, {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(d);
    const time = new Intl.DateTimeFormat(this.culture, {
      hour: "2-digit",
      minute: "2-digit",
    }).format(d);
    return `${date} · ${time}`;
  }

  locationLabel(b: any) {
    if (b.locationType === "online") {
      return this.$t("Online");
    }
    return b.locationName || b.fullAddress || b.place || "";
  }

  price(b: any) {
    if (b.totalAmount === null || b.totalAmount === undefined) {
      return "";
    }
    return Format.formatCurrency(b.totalAmount.toString());
  }

  async mounted() {
    let cid = 0;
    try {
      cid = JSON.parse(LocalStorage.getWithTimeout("cc")).id;
    } catch {
      console.error("not customer logged found");
    }

    await this.loadData(cid);
  }

  async loadData(customerId: number) {
    let url = `${Settings.HostName}/api/publicbookings/customer-bookings/${customerId}`;
    let data = await new CrudService().httpGet(url);
    if (data == null || data.ok === false) {
      console.error("Crash getting my bookings");
      return;
    }

    this.data = data.model;
    await this.loadVideoCalls();
  }

  async loadVideoCalls() {
    this.videoCalls = {};
    for (const b of this.next.filter((x: any) => x.isRemote === true)) {
      const res = await new CrudService().httpGet(
        `${Settings.HostName}/api/publicbookings/${b.id}/video-call`,
      );
      if (res && res.url) {
        this.$set(this.videoCalls, b.id, {
          url: res.url,
          from: new Date(res.availableFrom),
          to: new Date(res.availableTo),
        });
      }
    }
  }

  isCallOpen(id: number): boolean {
    const vc = this.videoCalls[id];
    const now = new Date();
    return vc !== undefined && now >= vc.from && now <= vc.to;
  }

  availableFromText(id: number): string {
    return this.$t("Available from {0}")
      .toString()
      .replace("{0}", DateHelper.toCultureTimeString(this.videoCalls[id].from));
  }

  async cancel(id: number, e: any) {
    this.errorMsg = "";
    e.preventDefault();
    let cid = 0;
    try {
      cid = JSON.parse(LocalStorage.getWithTimeout("cc")).id;
    } catch {
      console.error("not customer logged found");
    }

    const url = `${Settings.HostName}/api/publicbookings/cancel/${id}/${cid}`;
    let data = await new CrudService().httpPost(url);
    if (data == null) {
      console.error("Crash cancelling my bookings");
      return;
    }

    if (data.errorMsg !== null && data.errorMsg !== undefined) {
      this.errorMsg = data.errorMsg;
      return;
    }

    this.infoReturns = data.infoReturns;
    this.reload += 1;

    return await this.loadData(cid);
  }
}
